<template>
    <div class="fhv-centent"  v-loading="loading">
        <h4 class="title-topic">IP Filtering</h4>
            <el-form :model="From"
             :rules="rules"
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable IP Filtering:">
                <el-switch v-model="flag" @change="setIPFilterEnable"></el-switch>
            </el-form-item>
            <div v-if="flag">
                <el-form-item label="Filter Mode:" prop="location">
                    <el-radio v-model="From.ipv" label="0" @change="ipv">Enable IPv4 </el-radio>
                    <el-radio v-model="From.ipv" label="1"  @change="ipv">Enable IPv6</el-radio>
                </el-form-item>
                <el-form-item label="IP Filtering Mode:" prop="location">
                    <el-radio v-model="From.radio" label="0" @change="changeTab">Blacklist</el-radio>
                    <el-radio v-model="From.radio" label="1" @change="changeTab">Whitelist</el-radio>
                </el-form-item>
                <el-form-item :label="IPvname">
                    <el-col :span="11">
                        <el-form-item prop="ip1">
                        <el-input v-model="From.ip1" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2" style="text-align:center;">-</el-col>
                    <el-col :span="11">
                        <el-form-item prop="ip2">
                        <el-input v-model="From.ip2" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item :label="dIPvname">
                    <el-col :span="11">
                        <el-form-item prop="dip1">
                        <el-input v-model="From.dip1" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2" style="text-align:center;">-</el-col>
                    <el-col :span="11">
                        <el-form-item prop="dip2">
                        <el-input v-model="From.dip2" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="Interface Selection：" >
                        <el-select v-model="From.interface" placeholder="Please select" style="width: 100%">
                            <el-option v-for="(item,index) in selList" :key="index" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Protocol:" >
                        <el-select v-model="From.protocol" placeholder="Please select" style="width: 100%">
                            <el-option v-for="(item,index) in protocolList" :key="index" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                <el-form-item label="Comment:" prop="comment">
                    <el-input v-model="From.comment"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="add">Add</el-button>
                </el-form-item>
            </div>
            
            
        </el-form>

        <h4 v-html="txet">Current Blacklist Filter Table:</h4>
         <el-table :data="tableData" stripe style="width: 100%" border class="fhv-table">
            <el-table-column prop="address" label="Local IP Address" ></el-table-column>
            <el-table-column prop="eaddress" label="Local End IP Address"  v-if="From.flag"></el-table-column>
            <el-table-column prop="daddress" label="Destination IP Address" v-if="From.flag"></el-table-column>
            <el-table-column prop="deaddress" label="Destination End IP Address" v-if="From.flag" ></el-table-column>
            <el-table-column prop="protocol" label="Protocol" ></el-table-column>
            <el-table-column prop="name" label="Wan Name" v-if="From.flag"></el-table-column>
            <el-table-column prop="comment" label="Comment"></el-table-column>
            <el-table-column prop="" label="Select">
                  <template slot-scope="scope">
                    <el-button
                        @click.native.prevent="deleteRow(scope.row.index, tableData)"
                        :disabled="$G_DEVICE_CFG.isReadOnly"
                        type="text"
                        size="small">
                        Delete
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
  data() {
    return {
      txet: "Current Blacklist Filter Table:",
      IPvname: "Local IPv4 Address:",
      dIPvname: "Destination IPv4 Address:",
      mask: "",
      loading: false,
      flag: false,
      From: {
        flag: false,
        ip1: "",
        ip2: "",
        dip1: "",
        dip2: "",
        comment: "",
        radio: "1",
        ipv: "0",
        protocol: "0",
        interface: ""
      },
      selList: [],
      wanLists: [],
      protocolList: [
        { value: "0", label: "TCP+UDP" },
        { value: "1", label: "TCP" },
        { value: "2", label: "UDP" },
        { value: "3", label: "ICMP" }
      ],
      tableData: [],
      rules: {
        ip1: [
          {
            validator: (rule, value, callback) => {
              if (this.From.ipv == "0") {
                if (!validator.isIP(value, 4)){
                  callback(new Error("IPv4 Address Error!"));
                }else{
                   callback();
                }
              }else if(this.From.ipv == "1"){
                 if (!validator.isIP(value, 6)){
                  callback(new Error("IPv6 Address Error!"));
                }else{
                   callback();
                }
              }
            },
            trigger: "blur"
          }
        ],
        ip2: [
           {
            validator: (rule, value, callback) => {
              if (this.From.ipv == "0") {
                if (!validator.isIP(value, 4)){
                  callback(new Error("IPv4 Address Error!"));
                }else{
                   callback();
                }
              }else if(this.From.ipv == "1"){
                 if (!validator.isIP(value, 6)){
                  callback(new Error("IPv6 Address Error!"));
                }else{
                   callback();
                }
              }
            },
            trigger: "blur"
          }
        ],
        dip1: [
          {
            validator: (rule, value, callback) => {
              if (this.From.ipv == "0") {
                if (!validator.isIP(value, 4)){
                  callback(new Error("IPv4 Address Error!"));
                }else{
                   callback();
                }
              }else if(this.From.ipv == "1"){
                 if (!validator.isIP(value, 6)){
                  callback(new Error("IPv6 Address Error!"));
                }else{
                   callback();
                }
              }
            },
            trigger: "blur"
          }
        ],
        dip2: [
            {
            validator: (rule, value, callback) => {
              if (this.From.ipv == "0") {
                if (!validator.isIP(value, 4)){
                  callback(new Error("IPv4 Address Error!"));
                }else{
                   callback();
                }
              }else if(this.From.ipv == "1"){
                 if (!validator.isIP(value, 6)){
                  callback(new Error("IPv6 Address Error!"));
                }else{
                   callback();
                }
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    ipv() {
      this.IPvname =
        this.From.ipv == 0 ? "Local IPv4 Address:" : "Local IPv6 Address:";
      this.dIPvname =
        this.From.ipv == 0
          ? "Destination IPv4 Address:"
          : "Destination IPv6 Address:";
    },
    deleteRow(index, rows) {
      this.del(index);
    },
    del(index) {
      let postData
      if (index == "all") {
        postData = {
          Delete_All: "Delete All",
          submit_url: "/ip6filter.htm"
        };
      } else {
        postData = {
          deleteSelFilterIp: "Delete Selected",
          "submit-url": "/ip6filter.htm"
        };
        var name = `select${index}`;
        postData[name] = "ON";
      }

      this.loading = true;
      axios.post("/boafrm/setformFilter", postData).then(res => {
        this.loading = false;
        this.$message.success(res.data.msg);
        this.getData();
      });
    },
    getData() {
      let postData = {
        CmdType: "GET_WANLISTS"
      };
      this.loading = true;
      axios.post("/boafrm/fhPingInfo", postData).then(res => {
        this.loading = false;
        var data = res.data;
        this.wanLists = data.wanLists;
        this.selList = []
        if (data.ret == "0") {
          for (var i = 0; i < data.wanLists.length; i++) {
            this.selList.push({
              label: data.wanLists[i].name,
              value: `WAN${i + 1}`
            });
          }
        } else {
          this.$message.error(`Data acquisition error! Error message:${data.errorMsg}`);
        }
      });
      this.loading = true;
      axios.post("/boafrm/getIpFilterStatus").then(res => {
        this.loading = false;
     
        if (res.data.ipFilterEnabled == 1) {
          this.flag = true;
        }
        this.mask = res.data.mask;
        this.From.radio = res.data.ipFilterMode;
        if (this.From.radio == 0) {
          this.txet = "Current Blacklist Filter Table:";
          this.getBlackList();
        } else {
          this.getWihteList();
          this.txet = "Current Whitelist Filter Table:";
        }
      });
    },
    getBlackList() {
      this.loading = true;
      axios.post("/boafrm/getIpFilterBlack").then(res => {
        this.loading = false;
        let data = res.data;
        this.blackData = data;
        this.tableData = [];
        for (var i = 0; i < data.blackList.length - 1; i++) {
          if (data.blackList[i].endip != undefined) {
            this.From.flag = true;
            this.tableData.push({
              address: data.blackList[i].ip,
              eaddress: data.blackList[i].endip,
              daddress: data.blackList[i].dstip,
              deaddress: data.blackList[i].dstendip,
              protocol: data.blackList[i].type,
              name: data.blackList[i].wanBuf,
              comment: data.blackList[i].comment,
              index: data.blackList[i].index
            });
          } else {
            this.From.flag = false;
            this.tableData.push({
              address: data.blackList[i].ip,
              protocol: data.blackList[i].type,
              comment: data.blackList[i].comment,
              index: data.blackList[i].index
            });
          }
        }
      });
    },
    getWihteList() {
      this.loading = true;
      axios.post("/boafrm/getIpFilterWhite").then(res => {
        this.loading = false;
        let data = res.data;
        this.whiteData = data;
        this.tableData = [];
        for (var i = 0; i < data.whiteList.length - 1; i++) {
          if (data.whiteList[i].endip != undefined) {
            this.From.flag = true;
            this.tableData.push({
              address: data.whiteList[i].ip,
              eaddress: data.whiteList[i].endip,
              daddress: data.whiteList[i].dstip,
              deaddress: data.whiteList[i].dstendip,
              protocol: data.whiteList[i].type,
              name: data.whiteList[i].wanBuf,
              comment: data.whiteList[i].comment,
              index: data.whiteList[i].index
            });
          } else {
            this.From.flag = false;
            this.tableData.push({
              address: data.whiteList[i].ip,
              protocol: data.whiteList[i].type,
              comment: data.whiteList[i].comment,
              index: data.whiteList[i].index
            });
          }
        }
      });
    },
    changeTab() {
      let postData = {
        enabled: "ON",
        ipFilterMode: this.From.radio == 0 ? "off" : "on",
        addFilterIpFlag: "1",
        "submit-url": "/ip6filter.htm"
      };
      this.loading = true;
      axios.post("/boafrm/setformFilter", postData).then(res => {
        this.loading = false;
        if (this.From.radio == 0) {
          this.getBlackList();
          this.txet = "Current Blacklist Filter Table:";
        } else {
          this.getWihteList();
          this.txet = "Current Whitelist Filter Table:";
        }
        this.$message.success(res.data.msg);
      });
    },
    add() {
      let postData
      if (this.From.ipv == 0) {
        postData = {
          lan_mask: this.mask,
          enabled: this.flag == true ? "ON" : "",
          ip_version: this.From.ipv,
          ipFilterMode: this.From.radio == 0 ? "off" : "on",
          ip: this.From.ip1,
          ipend: this.From.ip2,
          dst_ip: this.From.dip1,
          dst_ipend: this.From.dip2,
          wanIndex: this.From.interface,
          protocol: this.From.protocol,
          comment: this.From.comment,
          addFilterIpFlag: "1",
          "submit-url": "/ip6filter.htm"
        };
      } else {
        postData = {
          lan_mask: this.mask,
          enabled: this.flag == true ? "ON" : "",
          ip_version: this.From.ipv,
          ipFilterMode: this.From.radio == 0 ? "off" : "on",
          ip6addr: this.From.ip1,
          ip6addrEnd: this.From.ip2,
          ip6Dstaddr: this.From.dip1,
          ip6DstaddrEnd: this.From.dip2,
          wanIndex: this.From.interface,
          protocol: this.From.protocol,
          comment: this.From.comment,
          addFilterIpFlag: "1",
          "submit-url": "/ip6filter.htm"
        };
      }
      if (!this.wanLists.length) {
        this.$message.error("WAN link is not found, please create first!");
        return;
      }
      if (!this.flag) {
        this.loading = true;
        axios.post("/boafrm/setformFilter", postData).then(res => {
          this.loading = false;
          this.getData();
        });
        return;
      }
      this.$refs["forms"].validate(valid => {
        if (valid) {
          this.loading = true;
          axios.post("/boafrm/setformFilter", postData).then(res => {
            this.loading = false;
            this.$message.success(res.data.msg);
            this.getData();
          });
        }
      });
    },
    setIPFilterEnable(val){
        this.loading = true;
        axios
        .post("/JSONAPI", {
            cmdType:"SET_IPFILTER_ENABLE",
            ipFilterEnable:val
        })
        .then(response => {
            this.loading = false
            if(response.data.ret === 0)
                this.$message.success('Set IP Filter Enbale success!')
            else
                this.$message.error(`Set IP Filter Enbale failed! Error:${response.data.errMsg}`)
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.fhv-centent {
  h4 {
    margin-bottom: 15px;
  }
  .btn-contain {
    width: 500px;
  }
  @media (max-width: 768px) {
    .btn-contain{
            width: 100%;
           padding-left: 0;
     }
  }
}
</style>




